import zhCN from './zh-CN.js'
import enUS from './en-US.js'
import ltLT from './lt-LT.js'
import ptPT from './pt-PT.js'
import esES from './es-ES.js'
import frFR from './fr-FR.js'
import itIT from './it-IT.js'
import deDE from './de-DE.js'

export default {
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'lt-LT': ltLT,
    'es-ES': esES,
    'pt-PT': ptPT,
    'fr-FR': frFR,
    'it-IT': itIT,
    'de-DE': deDE
  }
}
